/**
 * Sets a property on an object.
 * @param obj The object.
 * @param path The property name or deep path.
 * @param value The property value.
 */
export function setProperty(obj: any, path: string, value: any): any {

    if (path.indexOf('.') > -1) {

        const lastIndex = path.lastIndexOf('.');
        const parentName = path.substring(0, lastIndex);
        const name = path.substring(lastIndex + 1);
        const items = parentName.split('.');

        let inScope: any;

        items.forEach((item: string) => {

            if (!inScope) {

                inScope = obj[item];
            }
            else {

                inScope = inScope[item];
            }
        });

        if (inScope) {
            inScope[name] = value;
        }
    }
    else {

        obj[path] = value;
    }
}